<template>
  <EntertainmentArticle :article="article" />
</template>

<script>
import EntertainmentArticle from '../../components/EntertainmentArticle.vue'
import entertainmentArticles from '../../constant/entertainment'

export default {
  name: 'Doc9',
  components: {
    EntertainmentArticle,
  },
  data() {
    return {
      article: entertainmentArticles[8],
    }
  },
}
</script>
